<template>
	<div class="classes" v-if="eventInfo.length > 0">
		<v-container class="py-1">
			<v-layout row wrap inline-block justify-center>
				<v-flex xs12 sm12 md12>
					<v-card
						flat
						tile
						class="pa-4 Align text-uppercase"
						style="border-top: 1px solid black; border-bottom: 1px solid black;"
					>
						<h2>Upcoming {{ eventName }}</h2>
					</v-card>
				</v-flex>
				<v-flex
					xs12
					sm8
					md6
					id="about"
					v-for="(evt, i) in eventInfo"
					:key="evt.id"
				>
					<v-card
						flat
						tile
						class="ma-2 border-thing card-overflow"
						max-height="800"
						scrollable
					>
						<v-img class=" align-end" height="400" :src="evt.image">
							<v-overlay value="true" absolute>
								<h2 class="text-center pt-2">{{ evt.title }}</h2>
							</v-overlay>
						</v-img>
						<v-card-text>
							<b>Description:</b> {{ evt.description }}
						</v-card-text>
						<v-card-text><b> Date: </b>{{ evt.dateFormatted }} </v-card-text>
						<v-card-text v-if="evt.noSlot">
							<b>Time: </b>{{ evt.timeFormatted[0] }}</v-card-text
						>
						<v-card-text v-if="!evt.noSlot">
							<b>Time Slots: </b>
							<ul v-for="(slot, index) in evt.timeFormatted" :key="index">
								<li>
									{{ slot }}
								</li>
							</ul>
						</v-card-text>
						<v-card-text
							v-if="!evt.signupDisabled && evt.capacity && evt.capacity !== 0"
							class="green--text"
						>
							<b>Available Spots: </b>{{ evt.capacity }}</v-card-text
						>
						<v-card-text
							v-if="!evt.signupDisabled && evt.capacity === 0"
							class="red--text"
						>
							<b>Available Spots: </b>Online signup is full, call the shop for
							extra availability.</v-card-text
						>
						<v-card-text v-if="evt.signupDisabled" class="disabled-text">
							<b> Call the shop at 303-447-2400 for more information. </b>
						</v-card-text>
						<v-alert type="success" v-if="evt.success">
							You successfully signed up for {{ evt.title }}. A shop employee
							will contact you to confirm your attendance.
							<v-btn text v-on:click="evt.success = false"
								><v-icon class="font-weight-light">close</v-icon></v-btn
							>
						</v-alert>
						<v-btn
							block
							text
							@click="evt.show = !evt.show"
							v-if="!evt.signupDisabled && evt.capacity !== 0"
							:disabled="SignUpPast"
						>
							Sign Up <v-icon> expand_more </v-icon></v-btn
						>
						<v-expand-transition>
							<div v-show="evt.show">
								<v-form class="pa-6" v-model="valid">
									<v-divider></v-divider>
									<v-text-field
										label="Enter Name"
										v-model="Name"
										:rules="inputRules"
									></v-text-field>
									<v-text-field
										label="Enter Email"
										v-model="Email"
										:rules="inputRules"
									></v-text-field>
									<v-text-field
										label="Enter Phone Number"
										v-model="phoneN"
										:rules="inputRules"
									></v-text-field>
									<v-radio-group
										v-model="BAB.Tools"
										mandatory
										v-if="showCheckBox"
									>
										<p>Do you need to reserve a vise and tools?</p>
										<v-radio label="Yes" value="Yes"></v-radio>
										<v-radio label="No" value="No"></v-radio>
									</v-radio-group>
									<v-radio-group
										v-model="BAB.TiedBefore"
										mandatory
										v-if="showCheckBox"
									>
										<p>Have you tied flies before?</p>
										<v-radio label="Yes" value="Yes"></v-radio>
										<v-radio label="No" value="No"></v-radio>
									</v-radio-group>
									<v-btn
										text
										block
										class="button-img grey"
										v-on:click="addParticipant(i, evt.id)"
										:disabled="!valid"
									>
										Sign Up</v-btn
									>
								</v-form>
							</div>
						</v-expand-transition>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import fb from "@/fb";
import DateTime from "@/Models/DateTime";
import _ from "lodash";

export default {
	props: {
		eventName: {
			type: String,
			required: true,
		},
		eventID: {
			type: String,
			required: true,
		},
		about: {
			type: String,
			required: true,
		},
		disableAt: {
			type: Number,
			required: false,
		},
	},
	data() {
		return {
			BAB: {
				Tools: false,
				TiedBefore: false,
			},
			SignUpPast: false,
			showCheckBox: false,
			emails: [],
			eventInfo: [],
			shower: false,
			currentID: "",
			admin: true,
			phoneN: "",
			Email: "",
			Name: "",
			images: [
				{ src: "../img/Brown.jpg" },
				{ src: "../img/Leo.jpg" },
				{ src: "../img/troutskin.png" },
			],
			show: true,
			inputRules: [(v) => !!v || "Name is required"],
			valid: false,
			radios: null,
		};
	},
	watch: {
		// whenever question changes, this function will run
		eventID(newEventID, oldEventID) {
			if (newEventID !== oldEventID) {
				this.getEvents();
			}
		},
	},
	methods: {
		addParticipant: function(i, id) {
			let participant = {
				name: this.Name,
				email: this.Email,
				phone: this.phoneN,
				confirmation: false,
			};
			//if show box is true its bugs and brews so add extra questions to the firsbase call.
			if (this.showCheckBox) {
				participant.BAB = this.BAB;
			}

			fb.db
				.collection("Events")
				.doc(id)
				.collection("participants")
				.add(participant)
				.then(() => {
					this.shower = true;
					this.eventInfo[i].show = false;
					this.eventInfo[i].success = true;
				});
		},

		timeFormatted: function(time) {
			var timeFormatted;
			var timeCheck = time.slice(0, 2);
			if (timeCheck <= 12) {
				if (timeCheck >= 10 && timeCheck < 12) {
					timeFormatted = time.slice(0, 5) + " AM";
				} else if (timeCheck == 12) {
					timeFormatted = time.slice(0, 5) + " PM";
				} else {
					timeFormatted = time.slice(1, 5) + " AM";
				}
			} else {
				timeFormatted = timeCheck - 12 + time.slice(2, 5) + " PM";
			}
			return timeFormatted;
		},
		async getEvents() {
			if (this.eventID === "bugs-n-brews") {
				this.showCheckBox = true;
			}

			const eventBuilder = [];

			//get events by name
			const rawEvents = await fb.db
				.collection("Events")
				.where("location.id", "==", this.eventID)
				.get();

			if (rawEvents.docs.length > 0) {
				rawEvents.docs.forEach((doc) => {
					const eventDate = new Date(doc.data().timestamp);
					const today = new Date();
					eventDate.setDate(eventDate.getDate() + 1);
					//Add 1 day to the date of the event. Delete the event 1 day after its supposed to happen
					if (Date.parse(eventDate) < Date.parse(today)) {
						fb.db
							.collection("Events")
							.doc(doc.id)
							.delete();
						console.log("Delete from DB");
					} else {
						let timeFormatted = [];
						let newDateTime = [];
						let noSlot;
						//build timeslots for event viewing
						doc.data().timeSlots.forEach((slot) => {
							newDateTime.push(new DateTime(doc.data().date, slot));
							timeFormatted.push(this.timeFormatted(slot));
						});
						if (timeFormatted.length == 1) {
							noSlot = true;
						}
						if (timeFormatted.length > 1) {
							noSlot = false;
						}

						if (
							this.disableAt &&
							newDateTime[0].timeDifference < this.disableAt
						) {
							this.SignUpPast = true;
						}
						const offset = today.getTimezoneOffset() * 60000;
						//removed offset because its now applied when saved??
						let eventDate = new Date(doc.data().timestamp - offset);
						let dateFormatted = eventDate.toLocaleDateString("en-US", {
							weekday: "long",
							year: "numeric",
							month: "long",
							day: "numeric",
						});

						eventBuilder.push({
							...doc.data(),
							id: doc.id,
							show: false,
							timeFormatted: timeFormatted,
							dateFormatted: dateFormatted,
							noSlot: noSlot,
							success: false,
						});
					}
				});
				//sort after by timestamp
				this.eventInfo = _.orderBy(eventBuilder, ["timestamp"], ["asc"]);
			} else {
				this.eventInfo = eventBuilder;
				this.show = false;
			}
		},
	},

	created() {
		this.getEvents();

		//if a user is signed in populate the sign in with their information
		fb.auth.onAuthStateChanged((user) => {
			if (user) {
				fb.db
					.collection("users")
					.doc(user.uid)
					.get()
					.then((snapshot) => {
						this.Name = snapshot.data().fullName;
						this.phoneN = snapshot.data().phoneNumber;
						this.Email = user.email;
					});
			}
		});
	},
};
</script>
<style scoped>
.card-overflow {
	overflow: scroll;
}

.border-thing {
	border-top: 2px solid grey;
	border-bottom: 3px solid grey;
}
.Align {
	text-align: center;
}
.disabled-text {
	color: black;
	opacity: 1;
}
</style>
